// extracted by mini-css-extract-plugin
export default {"header-style":"Header_header-style__8Wph9","right-side":"Header_right-side__gCjsm","link":"Header_link__xIhZh","logo":"Header_logo__UsziS"};